/* ==========================================================================
   FX COLLECTION -- revelado sutil de tarjetas al entrar en viewport.
   Defensivo: si no hay grid en la pagina, no hace nada.
   ========================================================================== */
(function () {
  "use strict";

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  (function fxCollectionRevealModule() {
    const items = document.querySelectorAll(".fxcol-grid-item");
    if (!items.length || prefersReducedMotion) return;

    items.forEach((item) => {
      item.style.opacity = "0";
      item.style.transform = "translateY(12px)";
      item.style.transition = "opacity .5s cubic-bezier(.16,.9,.3,1), transform .5s cubic-bezier(.16,.9,.3,1)";
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = "1";
        entry.target.style.transform = "translateY(0)";
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });

    items.forEach((item) => observer.observe(item));
  })();

  (function fxCollectionCardVideoModule() {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const cards = Array.from(document.querySelectorAll(".fxc-card")).filter(
      (card) => card.querySelector(".fxc-media__video")
    );
    if (!cards.length) return;

    cards.forEach((card) => card.querySelector(".fxc-media__video").pause());

    if (prefersReducedMotion) return;

    const activeCards = new Set();

    async function activate(card, video) {
      activeCards.add(card);
      try {
        await video.play();
        if (activeCards.has(card)) {
          card.classList.add("fx-video-active");
        } else {
          video.pause();
        }
      } catch {
        video.pause();
        card.classList.remove("fx-video-active");
        activeCards.delete(card);
      }
    }

    function deactivate(card, video) {
      activeCards.delete(card);
      card.classList.remove("fx-video-active");
      video.pause();
    }

    const supportsHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (supportsHover) {
      cards.forEach((card) => {
        const video = card.querySelector(".fxc-media__video");
        card.addEventListener("mouseenter", () => activate(card, video));
        card.addEventListener("mouseleave", () => deactivate(card, video));
      });
      return;
    }

    const MAX_CONCURRENT = 1;
    const visibleCards = new Set();

    function reconcile() {
      const selected = Array.from(visibleCards).slice(0, MAX_CONCURRENT);

      Array.from(activeCards).forEach((card) => {
        if (!selected.includes(card)) {
          deactivate(card, card.querySelector(".fxc-media__video"));
        }
      });

      selected.forEach((card) => {
        if (!activeCards.has(card)) {
          activate(card, card.querySelector(".fxc-media__video"));
        }
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          if (entry.isIntersecting) {
            visibleCards.add(card);
          } else {
            visibleCards.delete(card);
          }
        });
        reconcile();
      },
      { threshold: 0.4 }
    );

    cards.forEach((card) => observer.observe(card));
  })();
})();
